// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3BMXk","footer":"ReportModalFilter_footer__7Lt2a"};